export class DataGridConstants {
  public static readonly rowHeight = 48;
}
